module.exports = __webpack_public_path__ + "img/logo.5186c31f.png";